import { createCarousel, CarouselConfig } from "utils/carousel"
import "./index.scss"

require.context("./static", true, /\.jpg|svg$/)

// Component-specific configuration
const config: CarouselConfig = {
  carouselSelector: ".carousel-photo-gallery__carousel",
  slideSelector: ".carousel-photo-gallery__carousel__slide",
  slideGap: 20,
  cssClass: "carousel-photo-gallery",
}

// Export the configured carousel instance
export const CarouselPhotoGallery = createCarousel(config)
